function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1306_21590)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.7625 4.48767L12.0125 0.737673C11.9796 0.700872 11.9391 0.671726 11.8937 0.652289C11.8484 0.632851 11.7993 0.623595 11.75 0.625172H4.25C3.95163 0.625172 3.66548 0.743699 3.4545 0.954677C3.24353 1.16566 3.125 1.4518 3.125 1.75017V3.62517H1.25C0.951631 3.62517 0.665483 3.7437 0.454505 3.95468C0.243526 4.16566 0.125 4.4518 0.125 4.75017V18.2502C0.125 18.5485 0.243526 18.8347 0.454505 19.0457C0.665483 19.2566 0.951631 19.3752 1.25 19.3752H11.75C12.0484 19.3752 12.3345 19.2566 12.5455 19.0457C12.7565 18.8347 12.875 18.5485 12.875 18.2502V16.3752H14.75C15.0484 16.3752 15.3345 16.2566 15.5455 16.0457C15.7565 15.8347 15.875 15.5485 15.875 15.2502V4.75017C15.8766 4.70085 15.8673 4.65179 15.8479 4.60644C15.8284 4.56108 15.7993 4.52054 15.7625 4.48767ZM12.125 18.2502C12.125 18.3496 12.0855 18.445 12.0152 18.5153C11.9448 18.5857 11.8495 18.6252 11.75 18.6252H1.25C1.15054 18.6252 1.05516 18.5857 0.984835 18.5153C0.914509 18.445 0.875 18.3496 0.875 18.2502V4.75017C0.875 4.65072 0.914509 4.55533 0.984835 4.48501C1.05516 4.41468 1.15054 4.37517 1.25 4.37517H8.59063L12.125 7.90955V18.2502ZM15.125 15.2502C15.125 15.3496 15.0855 15.445 15.0152 15.5153C14.9448 15.5857 14.8495 15.6252 14.75 15.6252H12.875V7.75017C12.8766 7.70085 12.8673 7.65179 12.8479 7.60644C12.8284 7.56108 12.7993 7.52054 12.7625 7.48767L9.0125 3.73767C8.97963 3.70087 8.93909 3.67173 8.89374 3.65229C8.84838 3.63285 8.79932 3.6236 8.75 3.62517H3.875V1.75017C3.875 1.65072 3.91451 1.55533 3.98483 1.48501C4.05516 1.41468 4.15054 1.37517 4.25 1.37517H11.5906L15.125 4.90955V15.2502Z",
  fill: "#333333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 8.5V12.25",
  stroke: "#333333",
  strokeWidth: 0.866025,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 14.5,
  r: 0.5,
  fill: "#333333"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1306_21590"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white"
})));

var SvgComplaint = function SvgComplaint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComplaint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/complaint.77227bbc.svg";
export { ForwardRef as ReactComponent };